<template>
  <div class="page-content need-love">
    <div class="row">
      <div class="col-sm-6 col-12">
        <create-form />
        <uber-lost-item />
      </div>

      <div class="col-sm-6 col-12">
        <request-supervisor-callback />
        <home-service-supervisor-support />
      </div>

      <div class="col-12">
        <search-form-stack />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="error-message">
            Please go to the site directly:&nbsp;
            <a
              href="https://www.formstack.com/admin/submission/report/11801682?share=suBQPJBwoq"
              target="_blank"
            >
              https://www.formstack.com/admin/submission/report/11801682?share=suBQPJBwoq
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const CreateForm = defineAsyncComponent(() => import('./NeedLove/CreateForm.vue') as any);

const RequestSupervisorCallback = defineAsyncComponent(() => import('./NeedLove/RequestSupervisorCallback.vue') as any);

const HomeServiceSupervisorSupport = defineAsyncComponent(() => import('./NeedLove/HomeServiceSupervisorSupport.vue') as any);

const UberLostItem = defineAsyncComponent(() => import('./NeedLove/UberLostItem.vue') as any);

const SearchFormStack = defineAsyncComponent(() => import('./NeedLove/SearchFormStack.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>

<style lang="scss">
.need-love {
  .error-message {
    font-size: 20px !important;
    padding: 20px 10px;
    a {
      text-decoration: none;
      color: #008b8b;
      &:hover {
        color: #f1590b;
      }
    }
  }
}
</style>
